"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFetchError = void 0;
const createFetchError = (requestId, message = 'Unknown') => ({
    body: `{ "error": "${message}" }`,
    headers: {
        'content-type': 'application/json',
    },
    id: requestId,
    ok: false,
    status: 0,
    statusText: 'ko',
});
exports.createFetchError = createFetchError;
//# sourceMappingURL=utils.js.map